import type { SceneryAirport, SceneryPresence } from "./types";
import { uniqueIcaosFromInventory } from "./sceneryScan";

export type SceneryInstallStatus = "installed" | "missing" | "unknown";

export function icaoInstalled(icao: string, inventory: SceneryPresence[]): boolean {
  const code = icao.trim().toUpperCase();
  return inventory.some((row) => row.icao.toUpperCase() === code);
}

export function sceneryStatus(icao: string, inventory: SceneryPresence[]): SceneryInstallStatus {
  if (!inventory.length) return "unknown";
  return icaoInstalled(icao, inventory) ? "installed" : "missing";
}

export function rankDestinations(
  destinations: SceneryAirport[],
  inventory: SceneryPresence[],
  gateOn: boolean,
): { dest: SceneryAirport; installed: boolean }[] {
  const rows = destinations.map((dest) => ({ dest, installed: icaoInstalled(dest.icao, inventory) }));
  if (!gateOn || !inventory.length) return rows;
  return [...rows].sort((a, b) => Number(b.installed) - Number(a.installed));
}

export function preferSceneryList(
  destinations: SceneryAirport[],
  inventory: SceneryPresence[],
  gateOn: boolean,
  allowUninstalled = true,
): SceneryAirport[] {
  const ranked = rankDestinations(destinations, inventory, gateOn);
  if (gateOn && inventory.length && !allowUninstalled) {
    const only = ranked.filter((r) => r.installed).map((r) => r.dest);
    return only.length ? only : ranked.map((r) => r.dest);
  }
  return ranked.map((r) => r.dest);
}

export function missingSceneryWarning(
  icao: string,
  inventory: SceneryPresence[],
  gateOn: boolean,
): string | undefined {
  if (!gateOn || !inventory.length) return undefined;
  if (icaoInstalled(icao, inventory)) return undefined;
  return `${icao.toUpperCase()} is not in this crew member’s Community scan. Suggest anyway is available.`;
}

export function preferIcaosFromInventory(inventory: SceneryPresence[], gateOn: boolean): string[] {
  if (!gateOn) return [];
  return uniqueIcaosFromInventory(inventory);
}
